module.exports = __webpack_public_path__ + "static/headshot--alt-61e4c7a9bf0dae40ffbb03908199dcb3.jpg";